import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Spinner } from "@/components/common/Common";
import { useAuth } from "@/context/AuthContext";
import { api, formatError } from "@/lib/api";
import { AuthLayout } from "./Login";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { refreshMe } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/auth/invite/${token}`).then((r) => { setInfo(r.data); setFullName(r.data.full_name || ""); }).catch((e) => setError(formatError(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Passwords do not match");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/accept-invite", { token, password, full_name: fullName });
      await refreshMe();
      navigate("/account?welcome=1", { replace: true });
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Accept your invitation" subtitle={info ? `Set a password for ${info.email}` : "Checking your invitation…"}>
      {info && (
        <form onSubmit={submit} className="space-y-4" data-testid="accept-invite-form">
          <div className="space-y-1.5"><Label>Full name</Label><Input value={fullName} onChange={(e) => setFullName(e.target.value)} data-testid="invite-name-input" /></div>
          <div className="space-y-1.5"><Label>Password (min 10 characters)</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={10} data-testid="invite-password-input" /></div>
          <div className="space-y-1.5"><Label>Confirm password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="invite-confirm-input" /></div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="invite-submit-button">{busy && <Spinner className="mr-2" />}Set password & sign in</Button>
        </form>
      )}
      {error && <p className="mt-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2" data-testid="invite-error">{error}</p>}
    </AuthLayout>
  );
}
